import { memo } from "react";
import Typography from "@mui/material/Typography";
import type { MerchantsMethodsPivot } from "features/pivots/types";
import Account from "ui/molecules/Account";
import CheckIcon from '@mui/icons-material/Check';

type Props = MerchantsMethodsPivot & {
    selected?: boolean;
    onSelectionChange?: (checked: boolean) => void;
};

const PaymentMethodName = ({
    paymentMethodPSP,
    paymentMethodIsAssignable,
    selected = false,
    onSelectionChange
}: Props) => {
    const isAssignable = Number(paymentMethodIsAssignable) === 1;

    return (
    <Account
        sx={{
            gridTemplateColumns: 'repeat(2, min-content)',
            gap: 2
        }}
        CustomAvatarProps={{
            color: selected ? 'success' : 'default',
            name: selected ? '' : paymentMethodPSP,
            alt: selected ? `${paymentMethodPSP} selected` : `Select ${paymentMethodPSP}`,
            children: selected ? <CheckIcon fontSize='small' /> : undefined,
            role: isAssignable ? 'checkbox' : undefined,
            'aria-checked': selected,
            tabIndex: isAssignable ? 0 : undefined,
            onClick: event => {
                event.stopPropagation();
                if (isAssignable) onSelectionChange?.(!selected);
            },
            onKeyDown: event => {
                if (isAssignable && (event.key === 'Enter' || event.key === ' ')) {
                    event.preventDefault();
                    event.stopPropagation();
                    onSelectionChange?.(!selected);
                }
            },
            sx: {
                cursor: isAssignable ? 'pointer' : 'not-allowed',
                outline: selected ? '2px solid' : 'none',
                outlineColor: 'success.light'
            }
        }}
    >
        <Typography
            variant='button'
        >
            {paymentMethodPSP}
        </Typography>
    </Account>
    );
};

export default memo(PaymentMethodName);
